import { AlgorithmLaunchType } from './../enums/LaunchType';
import { ItiBaseDto } from '@/iti-core-vue';
import { Dictionary } from 'vue-router/types/router';
import { Categories } from './categories';

export class Algorithm extends ItiBaseDto {
    public code!: string;
    public description!: string;
    public dockerImage!: string;
    public state!: boolean;
    public registered!: boolean;
    public imageEntryPoint!: string;
    public environmentVariables!: any;
    public moduleName!: string;
    public input!: string;
    public output!: string;
    public containerSlots!: number;
    public categories!: Categories[];
    public launchType!: AlgorithmLaunchType;
    public launchTypeName!: string;

    public environmentArray() {
        if (this.environmentVariables != null) {
            var entries = Object.entries(this.environmentVariables);
            if (entries == null)
                entries = [];
            var list: any[] = [];
            entries.forEach((element, index) => {
                if (element.length == 2)
                    list.push({ id: index, key: element[0], value: element[1] });
            });
            return list;
        } else {
            return null;
        }
    }

    public setEnvironmentVariablesFromArray(value: any[] | null) {
        if (value == null || value.length === 0){
            this.environmentVariables = null;
        } else {
            let newValue: any = {};
            value.forEach(element => {
                newValue[element.key] = element.value;
            });
            this.environmentVariables = newValue;
        }
    }


}